import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import "./index.css";
import Routers from "./routers/Routers";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routers />
        <Toaster richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
